import React from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { buildFullTranscriptText } from 'widgets/NoteTaker/utils/buildFullTranscriptText'
import { TRANSCRIPT_DRAWER_STATUS } from 'widgets/NoteTaker/types/sessionDrawer'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import s from '../NoteTakerDrawer.module.scss'

const SessionTranscriptPanel = observer(() => {
	if (!noteTakerStore.isTranscriptDrawerOpen) return null

	const status = noteTakerStore.transcriptDrawerStatus
	const cache = noteTakerStore.transcriptCache
	const fullTranscriptText = buildFullTranscriptText({
		transcriptText: cache?.text,
		transcriptSegments: cache?.segments,
	})

	return (
		<aside className={s.transcriptPanel} aria-label="Session transcript">
			<header className={s.transcriptHeader}>
				<h2>Transcript</h2>
				<button
					type="button"
					className={s.iconOnlyButton}
					aria-label="Close transcript"
					onClick={() => noteTakerStore.closeTranscriptDrawer()}
				>
					<CrossIcon />
				</button>
			</header>

			<div className={s.transcriptBody}>
				{status === TRANSCRIPT_DRAWER_STATUS.LOADING ? (
					<div className={s.transcriptState}>Loading transcript...</div>
				) : null}

				{status === TRANSCRIPT_DRAWER_STATUS.ERROR ? (
					<div className={s.transcriptState}>
						<p>
							{noteTakerStore.transcriptDrawerError?.message ||
								'Could not load transcript'}
						</p>
						<button type="button" onClick={() => noteTakerStore.retryTranscriptDrawer()}>
							Retry
						</button>
					</div>
				) : null}

				{status === TRANSCRIPT_DRAWER_STATUS.READY ? (
					fullTranscriptText ? (
						<div className={s.transcriptPlain}>{fullTranscriptText}</div>
					) : (
						<div className={s.transcriptState}>No transcript available.</div>
					)
				) : null}
			</div>
		</aside>
	)
})

export default SessionTranscriptPanel
